import '@material/web/field/filled-field.js';
import '@material/web/field/outlined-field.js';
import { LitElement, css } from 'lit';
import { property } from 'lit/decorators.js';
import { StaticValue, literal, html as staticHtml } from 'lit/static-html.js';

export class IxField extends LitElement {
  static override styles = css`
    .field {
      display: block;
    }
  `;

  @property({ type: Boolean }) filled = false;

  @property({ type: Boolean, reflect: true }) disabled = false;

  @property({ type: Boolean }) error = false;

  @property({ type: Boolean }) focused = false;

  @property() label = '';

  @property({ type: Boolean }) populated = false;

  @property({ type: Boolean }) required = false;

  @property({ type: Boolean }) resizable = false;

  @property({ attribute: 'supporting-text' }) supportingText = '';

  @property({ attribute: 'error-text' }) errorText = '';

  @property({ type: Number }) count = -1;

  @property({ type: Number }) max = -1;

  /**
   * Whether or not the field has leading content.
   */
  @property({ type: Boolean, attribute: 'has-start' }) hasStart = false;

  /**
   * Whether or not the field has trailing content.
   */
  @property({ type: Boolean, attribute: 'has-end' }) hasEnd = false;

  private input: HTMLInputElement | null = null;

  override connectedCallback() {
    super.connectedCallback();
    this.input = this.querySelector('input, textarea') as HTMLInputElement;
    this.handleSlotInput();
  }

  private handleSlotInput() {
    const length = this.input?.value?.length;
    this.count = length !== undefined ? length : this.count;
  }

  protected override render() {
    const tag: StaticValue = this.filled
      ? literal`md-filled-field`
      : literal`md-outlined-field`;

    return staticHtml`<${tag}
      ?disabled=${this.disabled}
      ?error=${this.error}
      error-text=${this.errorText}
      ?focused=${this.focused}
      label=${this.label}
      supporting-text=${this.supportingText}
      ?populated=${this.populated}
      ?required=${this.required}
      ?resizable=${this.resizable}
      count=${this.count}
      max=${this.max}
      ?has-start=${this.hasStart}
      ?has-end=${this.hasEnd}
      class="field"
    >
      <slot name="start" slot="start"></slot>
      <slot
      @input=${this.handleSlotInput}
      ></slot>
      <slot name="end" slot="end"></slot>
      <slot name="aria-describedby" slot="aria-describedby"></slot>
    </${tag}>`;
  }
}
